import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { ROOT_DOMAIN } from 'constants';

const RedirectForAnonymous = () => {
  useEffect(() => {
    const decoded = decodeURIComponent(window.location.search);
    const urlParams = new URLSearchParams(decoded);
    const anonymousToken = urlParams.get('anonymousToken') || urlParams.get('anonymous_token');
    if (!isEmpty(anonymousToken)) {
      window.location.href = `https://share.${ROOT_DOMAIN}?rut=${anonymousToken}`;
    }
  }, []);
  return null;
};

export default RedirectForAnonymous;
